import Home from "./home_root/home"
import Login from "./profile_root/login";
import Account from "./profile_root/account"
import Phoneverified from "./profile_root/phone-verified";
import PostJob from "./job_task_root/post-job";
import Createjob from "./companys_root/create-job";
import Emailchange from "./profile_root/email-change";
import Creativeportfolios from "./profile_root/creative-portfolios";
import Appdownload from "./download_root/app-dwonload";
import Typingmaster from "./tools_root/typing-master";
import Keyboard from "./pages/demo";
import Live from "./live_root/live";
//partners_root
import LocaleServices from "./partners_root/locale-services";
import AgencyInfo from "./partners_root/agency";
//terms
import Termsandconditions from "./terms_root/terms-and-conditions";
import Privacypolicy from "./terms_root/privacy-policy";
import Copyrightpolicy from "./terms_root/copyright-policy";
import Codeofconduct from "./terms_root/code-of-conduct";
import Feesandcharges from "./terms_root/fees-and-charges";
import Sitemap from "./terms_root/sitemap";
//Company Management
import CompanyManagement from "./companys_root/company-management";
import Photochange from "./profile_root/photo-change";
//companys
import Companys from "./companys_root/companys";
import Joblist from "./companys_root/jobs-list";
import JobApplied from "./companys_root/job-applied";
import JobTask from "./job_task_root/jobs";
//admin
import Admin from "./admin_root/admin";
import Adminjobcategories from "./admin_root/admin_jobcategories";
import Createcompanyprofile from "./companys_root/create-company-profile";
import Createjobtask from "./profile_root/create-job-task";
import Verifycompanyprofile from "./companys_root/verify-company-profile";
import Createjobprofile from "./profile_root/create-job-profile";
import Apply from "./job_task_root/apply";
import AccountDetails from "./profile_root/account-details";
import Help from "./help_root/help";
import Hireeditors from "./editor_root/hire-editors";
import Messageing from "./messaging_root/messageing";
//feed
import Feed from "./feed_root/feed";
import Feeddetails from "./feed_root/feed-details";
//dashboard_root 
import Dashboard from "./dashboard_root/dashboard";
//projects_root
import Projects from "./dashboard_root/projects_root/projects";
//workstation
import Workstation from "./workstation_root/workstation";
import Workhistory from "./workstation_root/work-history";
import Upcomingworktask from "./workstation_root/upcoming-task";
import Addtask from "./workstation_root/task_root/add-task"; 
import UpdateItemStatus from "./workstation_root/item_root/update-item-status";
import Teamroot from "./dashboard_root/team_root/team"; 
import ItemMasterManagemnet from "./workstation_root/item_master_root/item-master";
export const appRoutes = [
    { path: '/', name: 'Home', element: <Home /> },
    { path: '/live', name: 'Live rooms', element: <Live /> },
    //Feed
    { path: '/feed', name: 'Editor Feed', element: <Feed /> },
    { path: '/feed-details', name: 'Editor Feed', element: <Feeddetails /> },
    //
    { path: '/apply', name: 'Apply job', element: <Apply /> },
    { path: '/app-dwonload', name: 'Apply job', element: <Appdownload /> },
    { path: '/account', name: 'Account Settings', element: <Account /> },
    { path: '/email-change', name: 'Email change', element: <Emailchange /> },
    { path: '/phone-verified', name: 'Phone verified', element: <Phoneverified /> },
    { path: '/account-details', name: 'account-details Settings', element: <AccountDetails /> },
    { path: '/create-company-profile', name: 'Create Company Profile', element: <Createcompanyprofile /> },
    { path: '/verify-company-profile', name: 'Verify company profile', element: <Verifycompanyprofile /> },
    { path: '/create-job-task', name: 'Create Job Task', element: <Createjobtask /> },
    { path: '/hire-editors', name: 'Hire editors', element: <Hireeditors /> },
    { path: '/jobs', name: 'Jobs Task', element: <JobTask /> },
    { path: '/messageing', name: 'Messageing', element: <Messageing /> },
    { path: '/typing-master', name: 'Typing master', element: <Typingmaster /> },
    { path: '/demo', name: 'Messageing', element: <Keyboard /> },
    { path: '/creative-portfolios', name: 'Creative portfolios', element: <Creativeportfolios /> },
    { path: '/create-job-profile', name: 'Create Job profile', element: <Createjobprofile /> },
    { path: '/post-job', name: 'Editor Task Post job', element: <PostJob /> },
    { path: '/create-job', name: 'Editor Create job', element: <Createjob /> },
    { path: '/help', name: 'Help Center', element: <Help /> },
    //workstation
    { path: '/dashboard', name: 'Dashboard', element: <Dashboard /> },
    { path: '/update-item-status', name: 'update item work status', element: <UpdateItemStatus /> },
    { path: '/projects', name: 'Projects', element: <Projects /> },
    { path: '/work-history', name: 'My work', element: <Workhistory /> },
    { path: '/upcoming-task', name: 'Upcoming task', element: <Upcomingworktask /> },
    { path: '/add-task', name: 'Add new task', element: <Addtask /> }, 
     { path: '/team', name: 'Team', element: <Teamroot /> }, 
        { path: '/item-master', name: 'Team', element: <ItemMasterManagemnet /> }, 
    //profile

    { path: '/login', name: 'Account Login', element: <Login /> },
    { path: '/photo-change', name: 'Photo change', element: <Photochange /> },
    //CompanyManagement
    { path: '/companys', name: 'Company Management', element: <Companys /> },
    { path: '/company-management', name: 'Company Management', element: <CompanyManagement /> },

    { path: '/job-list', name: 'Company job list', element: <Joblist /> },
    { path: '/job-applied', name: 'Company job applied', element: <JobApplied /> },
    //partners_root
    { path: '/locale-services', name: 'Locale services', element: <LocaleServices /> },
    { path: '/agency', name: 'Locale services', element: <AgencyInfo /> },

    //terms

    { path: '/terms-and-conditions', name: 'Account Settings', element: <Termsandconditions /> },
    { path: '/privacy-policy', name: 'privacy policy', element: <Privacypolicy /> },
    { path: '/copyright-policy', name: 'Copyright policy', element: <Copyrightpolicy /> },
    { path: '/code-of-conduct', name: 'Code of Conduct - EditorTask', element: <Codeofconduct /> },
    { path: '/fees-and-charges', name: 'Code of Conduct - EditorTask', element: <Feesandcharges /> },
    { path: '/sitemap', name: 'Sitemap - EditorTask', element: <Sitemap /> },
    //admin
    { path: '/admin', name: 'Admin Settings', element: <Admin /> },
    { path: '/admin_jobcategories', name: 'Admin jobcategories', element: <Adminjobcategories /> }
]